module.exports = __webpack_public_path__ + "static/img/face2a.894fe51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/face2a.png
// module id = Xs+7
// module chunks = 1